import { render, staticRenderFns } from "./CompositionApiDemo.vue?vue&type=template&id=c9d5eefc&"
import script from "./CompositionApiDemo.vue?vue&type=script&lang=js&"
export * from "./CompositionApiDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports